module.exports = __webpack_public_path__ + "static/media/foodriver.13c134eb.png";